import { defineComponent as v, computed as n, openBlock as o, createElementBlock as t, normalizeClass as z, createBlock as I, unref as d, createCommentVNode as i, Fragment as y, createTextVNode as m, toDisplayString as a, renderSlot as E, withModifiers as b, createVNode as S } from "vue";
import { EChipVariants as g, EChipSizes as A, EChipEmphasis as B, EChipShapes as j, getInputChipPrependedIconSize as N, getInputChipStyleClasses as V } from "./novoui-vuejs69.js";
import "./novoui-vuejs71.js";
import "./novoui-vuejs72.js";
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs79.js";
import "./novoui-vuejs80.js";
import "./novoui-vuejs9.js";
import l from "./novoui-vuejs10.js";
import "./novoui-vuejs41.js";
import "./novoui-vuejs12.js";
import "./novoui-vuejs13.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs18.js";
import "./novoui-vuejs19.js";
import "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs22.js";
import "./novoui-vuejs23.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs28.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs110.js";
import "./novoui-vuejs39.js";
import "./novoui-vuejs40.js";
const $ = ["disabled"], w = {
  key: 0,
  class: "chip-input-prepend-container"
}, D = ["src"], ke = /* @__PURE__ */ v({
  __name: "NInputChip",
  props: {
    variant: { default: g.fill },
    size: { default: A.md },
    prependedIcon: {},
    prependedAvatar: {},
    prependedEmoji: {},
    disabled: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !1 },
    emphasis: { default: B.default },
    shape: { default: j.rounded },
    label: {}
  },
  emits: [
    /**
     * The event is emitted when the input chip is clicked
     */
    "click",
    /**
     * The event is emitted when the close button is clicked
     */
    "close"
  ],
  setup(c, { emit: u }) {
    const p = c, s = u, f = n(() => p.prependedEmoji || p.prependedIcon || p.prependedAvatar), C = n(() => N(p.size)), h = n(() => V(p));
    return (e, r) => (o(), t("button", {
      class: z(h.value),
      disabled: e.disabled,
      onClick: r[1] || (r[1] = (k) => s("click"))
    }, [
      f.value ? (o(), t("span", w, [
        e.prependedIcon ? (o(), I(d(l), {
          key: 0,
          icon: p.prependedIcon,
          size: C.value
        }, null, 8, ["icon", "size"])) : i("", !0),
        e.prependedAvatar && !e.prependedIcon ? (o(), t("img", {
          key: 1,
          src: e.prependedAvatar
        }, null, 8, D)) : i("", !0),
        e.prependedEmoji && !e.prependedAvatar && !e.prependedIcon ? (o(), t(y, { key: 2 }, [
          m(a(p.prependedEmoji), 1)
        ], 64)) : i("", !0)
      ])) : i("", !0),
      E(e.$slots, "default", {}, () => [
        m(a(e.label), 1)
      ]),
      e.closable ? (o(), t("span", {
        key: 1,
        class: "chip-input-close-container",
        onClick: r[0] || (r[0] = b((k) => s("close"), ["stop"]))
      }, [
        S(d(l), {
          icon: "closeSmall",
          size: p.size === "md" ? 16 : 14
        }, null, 8, ["size"])
      ])) : i("", !0)
    ], 10, $));
  }
});
export {
  ke as default
};
